import { getPageQuery } from "@/utils";
import { useDispatch } from "react-redux";
import { updateLanguage } from "@/state/user/reducer";
import { useEffect, useState } from "react";
import PageWrap from "@/components/PageWrap";
import BindPhone from "./BindPhone";
import { Box } from "@chakra-ui/react";
import LoginEmail from "./LoginEmail";
import SendPhoneCode from "./SendPhoneCode";
import VerifyGA from "./verifyGA";
import LoginAndRegisterBindGa from "@/pages/login/BindGa";

const Login = () => {
  const urlParams = getPageQuery();
  const language = urlParams.language;
  const dispatch = useDispatch();
  // INIT  VERIFY_PHONE_CODE BIND_PHONE_CODE BIND_GA
  const [loginStep, setLoginStep] = useState("INIT");
  const [phoneInfo, setPhoneInfo] = useState({
    phone_code: "",
    phone_number: "",
  });
  const [emailInfo, setEmailInfo] = useState("");
  const [password, setPassWord] = useState("");

  const toBindGa = ({ emailInfo, password }) => {
    setEmailInfo(emailInfo);
    setPassWord(password);
    setLoginStep("BIND_GA");
  };

  useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  useEffect(() => {
    if (language) {
      const maps = {
        cn: "zh",
        hk: "tw",
        en: "en",
      };
      if (maps[language]) {
        dispatch(updateLanguage({ language: maps[language] }));
      }
    }
  }, [language, dispatch]);

  return (
    <PageWrap logged={false}>
      <Box
        style={{ backgroundColor: "#fff" }}
        height={"auto"}
        minHeight={"100vh"}
        overflow={"hidden"}
      >
        {/* 邮箱登录 */}
        {loginStep === "INIT" && (
          <LoginEmail
            toNextStep={({
              emailInfo,
              phoneInfo,
              password,
              has_google_auth,
            }) => {
              // 如果用户有ga，则等于true，直接输入ga，
              if (has_google_auth) {
                setEmailInfo(emailInfo);
                setPassWord(password);
                setLoginStep("VERIFY_GA");
              } else {
                setEmailInfo(emailInfo);
                setPhoneInfo(phoneInfo);
                setPassWord(password);
                if (phoneInfo?.phone_number) {
                  // 如果用户无ga，且phone_code和phone_number不等于空，则和以前流程一样，验证手机号验证码。
                  setLoginStep("VERIFY_PHONE_CODE");
                } else {
                  // 如果用户无ga，且phone_code和 phone_number都等于空，则需要用户输入支付密码。
                  setLoginStep("BIND_GA");
                }
              }
            }}
            // toBindPhone={({ emailInfo, phoneInfo, password }) => {
            //   setEmailInfo(emailInfo);
            //   setPhoneInfo(phoneInfo);
            //   setPassWord(password);
            //   setLoginStep("BIND_PHONE_CODE");
            // }}
          />
        )}
        {/* 绑定GA，使用GA完成登录 */}
        {loginStep === "VERIFY_GA" && (
          <VerifyGA emailInfo={emailInfo} password={password} />
        )}

        {/* 绑定手机号时去发送验证码 */}
        {loginStep === "VERIFY_PHONE_CODE" && (
          <SendPhoneCode
            phoneInfo={phoneInfo}
            emailInfo={emailInfo}
            password={password}
            toBindGa={toBindGa}
          />
        )}
        {/* 没有绑定手机号时 去绑定手机号*/}
        {loginStep === "BIND_PHONE_CODE" && (
          <BindPhone
            emailInfo={emailInfo}
            password={password}
            phoneInfo={phoneInfo}
          />
        )}
        {/* 绑定GA */}
        {loginStep === "BIND_GA" && (
          // {loginStep === "INIT" && (
          <LoginAndRegisterBindGa
            emailInfo={emailInfo}
            password={password}
            needVerifyPaymentPassword={phoneInfo?.phone_number ? false : true}
          />
        )}
      </Box>
    </PageWrap>
  );
};

export default Login;
